import { useLingui } from "@lingui/react/macro";
import { Button } from "@rakazo/ui-web";
import { Activity, Monitor, Folder, Clock3, Fingerprint, X } from "lucide-react";
import type { Panel } from "../../lib/right-panel-state";

export function BotPanelNav({
  panel,
  onChange,
  onClose,
}: {
  panel: Panel;
  onChange: (panel: Panel) => void;
  onClose: () => void;
}) {
  const { t } = useLingui();
  const tabs = [
    { panel: "settings", label: t`Identity`, icon: Fingerprint },
    { panel: "library", label: t`Library`, icon: Folder },
    { panel: "routines", label: t`Routines`, icon: Clock3 },
    { panel: "activity", label: t`Activity`, icon: Activity },
    { panel: "computer", label: t`Computer`, icon: Monitor },
  ] as const;
  return (
    <nav
      aria-label={t`Bot panels`}
      data-testid="bot-panel-nav"
      className="flex w-full items-center justify-between"
    >
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const selected = panel === tab.panel || (tab.panel === "routines" && panel === "routine");
        return (
          <Button
            key={tab.panel}
            variant="ghost"
            size="icon-sm"
            title={tab.label}
            aria-label={tab.label}
            aria-pressed={selected}
            data-testid={`bot-${tab.panel === "settings" ? "identity" : tab.panel}-trigger`}
            onClick={() => onChange(tab.panel)}
            className={selected ? "bg-accent text-foreground" : "text-muted-foreground"}
          >
            <Icon size={16} strokeWidth={1.7} />
          </Button>
        );
      })}
      <Button
        variant="ghost"
        size="icon-sm"
        aria-label={t`Close panel`}
        title={t`Close`}
        onClick={onClose}
      >
        <X size={16} strokeWidth={1.8} />
      </Button>
    </nav>
  );
}
